import * as layout from './layout';

export const COMPACT = `(max-width: ${layout.MAX_WIDTH__COMPACT}px)`;
export const REGULAR = `(min-width: ${layout.MIN_WIDTH__REGULAR}px)`;



// WEBPACK FOOTER //
// ./src/theme/breakpoints.js